<template>
    <div>
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>业务参数</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="tab-container small base">
            <div class="tabs-nav">
                <ul class="head">
                    <li :class="{'current': status.value == checkStateValue}" class="head-item" v-for="status in tableState" @click="handleTabClick(status.value)">
                        <span>{{status.text}}</span>
                    </li>
                </ul>
            </div>
        </div>
        <div v-if="checkStateValue === 0">
            <swb-merchant-biz-param-list :groupCodeList="groupCodeList"></swb-merchant-biz-param-list>
        </div>
        <div v-else>
            <swb-org-biz-param-list :channelCode="'bizParamRepair'"></swb-org-biz-param-list>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    //
    import SwbMerchantBizParamList from './MerchantBizParamList';
    Vue.regist(SwbMerchantBizParamList);
    import SwbOrgBizParamList from './OrgBizParamList';
    Vue.regist(SwbOrgBizParamList);
    //
    export default{
        name: 'swb-biz-param-list-for-repair',
        path: '/biz/param/list/for/repair',
        avlScopes: 'retailer',
        desc: '维保服务-业务参数',
        helpArticleCode: 'retailer-biz-param-list-for-repair',
        data: function () {
            return {
                checkStateValue: 0,
                tableState: [{
                    "text": "商户级",
                    "value": 0,
                }, {
                    "text": "机构级",
                    "value": 1,
                }],
                // [维保业务设置]
                groupCodeList: ["asset.setting"]
            }
        },
        created: function () {
        },
        methods: {
            handleTabClick(val) {
                this.checkStateValue = val;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/bizParam/BizParamListForRepair.vue